// pages/About.js
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './About.css';

const About = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page-wrap">
      {/* Page Title */}
      <div className="about-hero">
        <h1>{t('aboutPage.title')}</h1>
        <p>{t('aboutPage.subTitle')}</p>
      </div>

      {/* Story Grid */}
      <div className="about-section-grid">
        <div className="about-text-block">
          <h2>{t('aboutPage.storyTitle')}</h2>
          <p>{t('aboutPage.storyText')}</p>
        </div>
        <div className="about-visual-block">
          <div className="about-visual-badge">
            <img src="/partners-itu-cekirdek.png" alt="İTÜ Çekirdek Logo" />
          </div>
          <h3>İTÜ Çekirdek</h3>
          <p>{t('aboutPage.ituDescription')}</p>
        </div>
      </div>

      {/* Mission / Vision Cards */}
      <div className="mv-section">
        <div className="mv-grid">
          <div className="mv-card">
            <h2>🎯 {t('aboutPage.missionTitle')}</h2>
            <p>{t('aboutPage.missionText')}</p>
          </div>
          <div className="mv-card">
            <h2>⚡ {t('aboutPage.visionTitle')}</h2>
            <p>{t('aboutPage.visionText')}</p>
          </div>
        </div>
      </div>

      {/* Operations Research / Heuristics Section */}
      <div className="or-section">
        <div className="or-grid">
          <div className="or-visual">
            <div className="or-math-mock">
              <span className="math-comment">{"// Mixed Integer Program (MIP) Objective"}</span>
              <div className="math-equation">Minimize ∑ (c_ij * x_ij) + ∑ (f_k * y_k)</div>
              <span className="math-comment">{"// Subject to constraints:"}</span>
              <div className="math-equation">∑ x_ij = 1  (∀ j ∈ Tasks)</div>
              <div className="math-equation">∑ q_j * x_ij ≤ Q_i  (∀ i ∈ Crews)</div>
              <div className="math-equation">t_i + d_ij + s_j ≤ t_j  (Time windows)</div>
              <span className="math-comment">{"// Solved via tabu search & MIP in 24ms"}</span>
            </div>
          </div>
          <div className="about-text-block">
            <h2>{t('aboutPage.orTitle')}</h2>
            <p>{t('aboutPage.orText')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
